import { Switch, Route } from "react-router-dom";
import React from "react";
import LoginPage from "./login/components/loginPage";
import ForgotPassword from "./login/components/forgotPassword";
import RegisterPage from "./login/components/RegisterPage";
import Home from "./home";
import CustomersPage from "./customers/components/customersPage";
import TipiContrattoPage from "./tipiContratto/components/tipoContrattoPage";
import TipiContrattoEdit from "./tipiContratto/components/tipoContrattoEdit";
import ContrattoEdit from "./contratti/components/ContrattoEdit";
import CustomerEdit from "./customers/components/customerEdit";
import CustomerShow from "./customers/components/customerShow";
import CaldaiePage from "./caldaie/components/caldaiePage";
import CaldaieImport from "./caldaie/components/CaldaieImport";
import CaldaiaEdit from "./caldaie/components/caldaiaEdit";
import BruciatorePage from "./bruciatori/components/bruciatorePage";
import BruciatoreEdit from "./bruciatori/components/bruciatoreEdit";
import TechniciansPage from "./technicians/components/TechniciansPage";
import TechniciansEdit from "./technicians/components/TechnicianEdit";
import ImpiantoEdit from "./impianti/components/impiantoEdit";
import { InterventoEditPage, InterventoNewPage } from "./interventi/components/InterventoPage";
import InterventiCalendarPage from "./interventi/components/InterventiCalendarPage";
import InterventiPage from "./interventi/components/InterventiPage";
import CompanyOperatorsPage from "./login/components/companyOperatorsPage";
import CompanyEditPage from "./login/components/companyEditPage";
import ExpirationsPage from "./expirations/components/expirationsPage";
import ExpirationSettingsPage from "./expirations/components/expirationsSettingsPage";
import OperatorePage from "./login/components/operatorEdit";
import ResetPassword from "./login/components/resetPassword";
import PaymentsPage from "./payment/components/paymentsPage";
import BuySms from "./payment/components/buySms";
import { BaseUrl } from "./BaseClient";
import { Link } from "./common/components/link";
import { canRequireUser, accountIsExpired } from "./login/loginHelpers";
import { AccountData, ApparecchioCategoryType } from "./generated";
import { PaymentOk, PaymentKo, PaymentSmsOk } from "./payment/components/paymentResult"
import News from "./news/components/NewsPage"
import InterventiReport from "./interventi/components/InterventiReport";
import BrandsReportsPage from "./dashboard/components/BrandsReportsPage";
import PlantsReplacementsReport from "./dashboard/components/PlantsReplacementsReport";
import notifications from "./expirations/components/notifications";
import impiantoSelectionPage from "./impianti/components/impiantoSelectionPage";
import impiantoNew from "./impianti/components/impiantoNew";
import ImpiantoClimaNew from "./impiantiClima/components/ImpiantoClimaNew";
import ImpiantoClimaEdit from "./impiantiClima/components/ImpiantoClimaEdit";

export const links = {

  home: "/",
  login: "/login",
  register: "/register",
  customers: "/customers",

  customerShowTemplate: `/customers/:id`,
  customerEditTemplate: `/customers/:id/edit`,
  customerNew: `/customers/new`,
  customerEdit: (id: number) => `/customers/${id}/edit`,
  customerShow: (id: number) => `/customers/${id}`,

  tipiContratto: "/contractTypes",
  tipoContrattoNew: `/contractTypes/new`,
  tipoContrattoTemplate: `/contractTypes/:id`,
  tipoContrattoEdit: (id: string) => `/contractTypes/${id}`,


  contrattiNew: (idImpianto: number) => `/contratti/${idImpianto}/new`,
  contrattiNewTemplate: "/contratti/:idImpianto/new",

  caldaie: `/caldaie`,
  caldaieNew: `/caldaie/new`,
  caldaieImport: `/caldaie/import`,
  caldaieTemplate: `/caldaie/:id`,
  caldaieEdit: (id: number) => `/caldaie/${id}`,

  bruciatori: `/bruciatori`,
  bruciatoriNew: `/bruciatori/new`,
  bruciatoriTemplate: `/bruciatori/:id`,
  bruciatoriEdit: (id: number) => `/bruciatori/${id}`,

  technicians: `/technicians`,
  techniciansNew: `/technicians/new`,
  techniciansTemplate: `/technicians/:id`,
  technicianEdit: (id: number) => `/technicians/${id}`,

  impiantoSelectionTemplate: `/customers/:idCliente/impianto/selection`,
  impiantoSelection: (idCliente: number) => `/customers/${idCliente}/impianto/selection`,
  impiantoEditTemplate: `/impianti/:id`,
  impiantoEdit: (id: number) => `/impianti/${id}`,
  impiantoNewTemplate: `/customers/:idCliente/impianti/:category/new`,
  impiantoNew: (idCliente: number, category: ApparecchioCategoryType) => `/customers/${idCliente}/impianti/${category}/new`,

  impiantoClimaEditTemplate: `/impianticlima/:id`,
  impiantoClimaEdit: (id: number) => `/impianticlima/${id}`,
  impiantoClimaNewTemplate: `/customers/:idCliente/impianticlima/:category/new`,
  impiantoClimaNew: (idCliente: number, category: ApparecchioCategoryType) => `/customers/${idCliente}/impianticlima/${category}/new`,

  interventiTemplate: `/interventi/:idCliente`,
  interventi: (idCliente: number) => `/interventi/${idCliente}`,
  interventiReport: `/interventireport`,
  interventoTemplateNew: `/interventi/new`,
  interventoNew: (customerData?: { idCliente: number, idImpianto?: number }, from?: Date, to?: Date) => {
    let url = `/interventi/new`;
    let parameters: string[] = [];
    if (customerData) {
      parameters.push(`idCliente=${customerData.idCliente}`);
      if (customerData.idImpianto) {
        parameters.push(`idImpianto=${customerData.idImpianto}`);
      }
    }
    if (from) {
      parameters.push(`from=${from.toISOString()}`);
    }
    if (to) {
      parameters.push(`to=${to.toISOString()}`)
    }
    return parameters.length > 0 ? `${url}?${parameters.join("&")}` : url;
  },

  interventoTemplateEdit: `/interventi/:idCliente/:id`,
  interventoEdit: (idCliente: number, id: number) => `/interventi/${idCliente}/${id}`,

  activityTemplateNew: `/activity/new`,
  activityTemplateEdit: `/activity/:id`,
  activityEdit: (id: number) => `/activity/${id}`,

  interventiCalendar: `/calendar`,
  companyEdit: "/company",

  operatorEdit: (id: number) => `/operators/${id}`,
  operatorNew: `/operators/new`,
  operatorEditTemplate: `/operators/:id`,

  companyOperators: "/companyoperators",
  expirations: "/expirations",
  expirationsSettings: "/expirationssettings",
  paymentPage: "/payment",
  paymentOkPage: "/paymentok",
  paymentSmsOkPage: "/paymentsmsok",
  paymentKoPage: "/paymentko",

  notifications: "/notifications",
  buySms: "/buySms",

  forgotPassword: "/forgotPassword",
  resetPassword: "/resetPassword",
  brandsReport: "/brandsreport",
  plantsReplacementsReport: "/replacementsreport",
  rapportoControllo(year: number, number: number, type: number) {
    return `${BaseUrl}/rapporticontrollolayout/generate?year=${year.toString()}&number=${number.toString()}&type=${type}`
  },
  rapportoControlloEmpty(idImpianto: number, type: number) {
    return `${BaseUrl}/rapporticontrollolayout/empty?idImpianto=${idImpianto.toString()}&type=${type}`
  },
  news: "/news",
  landingUrl: BaseUrl,
  rapportinoUrl(idIntervento: number) {
    return `${BaseUrl}/interventilayout/generate?idIntervento=${idIntervento.toString()}`
  },
}

export const CmRouter = (props: { user: AccountData | null }) => {
  if (!props.user)
    return <Switch>
      <Route path={links.forgotPassword} component={ForgotPassword} />
      <Route path={links.resetPassword} component={ResetPassword} />
      <Route path={links.register} component={RegisterPage} />
      <Route component={LoginPage} />
    </Switch>
  if (accountIsExpired(props.user)) {
    return <Switch>
      <Route path={links.login} component={LoginPage} />
      <Route path={links.forgotPassword} component={ForgotPassword} />
      <Route path={links.resetPassword} component={ResetPassword} />
      <Route path={links.register} component={RegisterPage} />
      <Route path={links.paymentPage} component={PaymentsPage} />
      <Route path={links.paymentOkPage} component={PaymentOk} />
      <Route path={links.paymentKoPage} component={PaymentKo} />
      <Route path={links.news} component={News} exact />
      <Route path={links.home} component={Home} exact />
    </Switch>
  }
  return (
    <Switch>
      <Route path={links.login} component={LoginPage} />
      <Route path={links.forgotPassword} component={ForgotPassword} />
      <Route path={links.resetPassword} component={ResetPassword} />
      <Route path={links.register} component={RegisterPage} />

      <Route path={links.impiantoNewTemplate} component={impiantoNew} />
      <Route path={links.impiantoEditTemplate} component={ImpiantoEdit} />

      <Route path={links.impiantoClimaNewTemplate} component={ImpiantoClimaNew} />
      <Route path={links.impiantoClimaEditTemplate} component={ImpiantoClimaEdit} />

      <Route path={links.impiantoSelectionTemplate} component={impiantoSelectionPage} />

      <Route path={links.interventoTemplateNew} component={InterventoNewPage} />
      <Route path={links.interventoTemplateEdit} component={InterventoEditPage} />
      <Route path={links.interventiTemplate} component={InterventiPage} />
      <Route path={links.interventiCalendar} component={InterventiCalendarPage} />
      <Route path={links.interventiReport} component={InterventiReport} />

      <Route path={links.customerNew} component={CustomerEdit} />
      <Route path={links.customerEditTemplate} component={CustomerEdit} />
      <Route path={links.customerShowTemplate} component={CustomerShow} />
      <Route path={links.customers} component={CustomersPage} />

      <Route path={links.tipoContrattoNew} component={TipiContrattoEdit} />
      <Route path={links.tipoContrattoTemplate} component={TipiContrattoEdit} />
      <Route path={links.tipiContratto} component={TipiContrattoPage} />

      <Route path={links.contrattiNewTemplate} component={ContrattoEdit} />

      <Route path={links.caldaieNew} component={CaldaiaEdit} />
      <Route path={links.caldaieImport} component={CaldaieImport} />
      <Route path={links.caldaieTemplate} component={CaldaiaEdit} />
      <Route path={links.caldaie} component={CaldaiePage} />

      <Route path={links.bruciatoriNew} component={BruciatoreEdit} />
      <Route path={links.bruciatoriTemplate} component={BruciatoreEdit} />
      <Route path={links.bruciatori} component={BruciatorePage} />

      <Route path={links.techniciansNew} component={TechniciansEdit} />
      <Route path={links.techniciansTemplate} component={TechniciansEdit} />
      <Route path={links.technicians} component={TechniciansPage} />

      <Route path={links.companyEdit} component={CompanyEditPage} />
      <Route path={links.companyOperators} component={CompanyOperatorsPage} />
      <Route path={links.operatorNew} component={OperatorePage} />
      <Route path={links.operatorEditTemplate} component={OperatorePage} />

      <Route path={links.expirations} component={ExpirationsPage} />
      <Route path={links.expirationsSettings} component={ExpirationSettingsPage} />
      <Route path={links.paymentPage} component={PaymentsPage} />
      <Route path={links.paymentOkPage} component={PaymentOk} />
      <Route path={links.paymentKoPage} component={PaymentKo} />

      <Route path={links.notifications} component={notifications} />
      <Route path={links.buySms} component={BuySms} />
      <Route path={links.paymentSmsOkPage} component={PaymentSmsOk} />

      <Route path={links.news} component={News} exact />
      <Route path={links.brandsReport} component={BrandsReportsPage} exact />
      <Route path={links.plantsReplacementsReport} component={PlantsReplacementsReport} exact />
      <Route path={links.home} component={Home} exact />
      <Route
        component={() => <>
          <h1 className="mt-4">Pagina non trovata</h1>
          <div>
            <Link to={links.home}>Torna alla home</Link>
          </div>
        </>}
      />
    </Switch>
  );
}

export default canRequireUser(CmRouter);

